<template>
	<div name="hress5u-popup1" id="hress5u-popup1" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRESS5UC5']['0'] }}</h4>
        </div>
        
        <div class="modal-body detail detail-responsive">
				
					<div class="clearfix detail-row">
						<div class="detail-left label-left">{{ labels['HRESS5UC5']['20'] }}</div>
						<div class="detail-right">
						   <div class="detail-text width-100" id="numreqst" name="numreqst">{{ popup1DetailTab2.tab1.numreqst }}</div>
						</div>
					</div>
					<div class="clearfix detail-row">
						<div class="detail-left label-left">{{ labels['HRESS5UC5']['30'] }}</div>
						<div class="detail-right">
						    <div class="detail-text width-100" id="coddesc_codpos" name="coddesc_codpos">{{ popup1DetailTab2.tab1.codpos }} - {{ popup1DetailTab2.tab1.desc_codpos }}</div>
						</div>
					</div>
			
		
					<div id="accordion-tab2Popup1Tab1">  
	          <div class="panel box-collapse border-color-skin">
			        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion-tab2Popup1Tab1" href="#detailsPopup1Tab1">
			          <h3 class="box-title">
			            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS5UC5']['0'] }}
			          </h3>
			        </div>

			        <div id="detailsPopup1Tab1" class="panel-collapse collapse in tab-detail">
			          <div class="panel-body">
			          	<div class="clearfix detail-row">
				            <div class="detail-left label-left">{{ labels['HRESS5UC5']['40'] }}</div>
				            <div class="detail-right">
				                <div class="detail-text width-100" id="coddesc_codjob" name="coddesc_codjob">{{ popup1DetailTab2.tab1.codjob }} - {{ popup1DetailTab2.tab1.desc_codjob }}</div>
				            </div>
					        </div>

					        <div class="clearfix detail-row">
				            <div class="detail-left label-left">{{ labels['HRESS5UC5']['50'] }}</div>
				            <div class="detail-right">
				                <div class="detail-text width-100" id="desnoffi" name="desnoffi">{{ popup1DetailTab2.tab1.desnoffi }}</div>
				            </div>
					        </div>

					        <div>
				            <div class="clearfix detail-row">
			                <div class="detail-left label-left">{{ labels['HRESS5UC5']['0'] }}</div>
			                <div class="detail-right">
			                		<input type="checkbox" value="Y" readonly="readonly" disabled="disabled" v-model="popup1DetailTab2.tab1.flgjob" >
                          {{ labels['HRESS5UC5']['70'] }}

                          <input type="checkbox" value="Y" readonly="readonly" disabled="disabled" v-model="popup1DetailTab2.tab1.flgcond" >
                          {{ labels['HRESS5UC5']['80'] }}
			                </div>
				            </div>
				        	</div>

					        <div class="clearfix detail-row">
				            <div class="detail-left label-left">{{ labels['HRESS5UC5']['90'] }}</div>
				            <div class="detail-right">
				                <div class="detail-text txtarea-width width-100" id="syncond" name="syncond">{{ popup1DetailTab2.tab1.syncond }}</div>
				            </div>
					        </div>

					        <div class="clearfix detail-row">
				            <div class="detail-left label-left">{{ labels['HRESS5UC5']['100'] }}</div>
				            <div class="detail-right">
				                <div class="detail-text txtarea-width width-100" id="desnote" name="desnote">{{ popup1DetailTab2.tab1.desnote }}</div>
				            </div>
					        </div>	    
			          </div>
			        </div>
		        </div>
        	</div>			
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
export default {
  name: 'hress5u-popup1',
  props: [ 'labels', 'popup1DetailTab2' ]
}
</script>





// WEBPACK FOOTER //
// popup1.vue?c7f34860